// import DocumentationSideBar from './DocumentationSideBar';
import './DocumentationPages.css';

const DocumentationBasePage = ({ children }) => {
  return (
    <div style={{ display: 'flex' }}>
      {/* <DocumentationSideBar /> */}
      <div
        id="user_guide"
        style={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          background: '#CEDBD6',
          flexGrow: 1,
          // Lets the guide shrink to the screen; its widest content (code,
          // long URLs) otherwise sets the page width.
          minWidth: 0,
        }}
      >
        <div
          style={{
            backgroundSize: 'cover',
            backgroundColor: 'white',
          }}
        >
          <div
            style={{
              margin: '30px 8%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <h1
              style={{
                color: '#2C3E37',
                fontWeight: 'bolder',
                fontSize: '36px',
              }}
            >
              California Wildfire Commons User Guide
            </h1>
          </div>
        </div>{' '}
        {children}
      </div>
    </div>
  );
};
export default DocumentationBasePage;
